"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2202],{

/***/ 2202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51252);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56941);
/* harmony import */ var react_contextual__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80224);
/* harmony import */ var _common_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50386);
/* harmony import */ var _common_colors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_common_colors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78659);
/* harmony import */ var _icons_locationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11262);
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95820);
/* harmony import */ var _elements_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49635);
/* harmony import */ var _util_selectSuggestedPrice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6549);
/* harmony import */ var _matchedAmount__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20314);














function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var fullySupportedBoxStyle = {
    margin: 0,
    padding: '5px',
    display: 'inline-block',
    border: '1px solid #ff5050',
    borderRadius: '5px'
};
var ProgramCard = function(props) {
    var _program = props.program, cause = _program.cause, location = _program.location, title = _program.title, ngo = _program.ngo, price = _program.price, image = _program.image, alt = _program.alt, id = _program.id, programLink = _program.programLink, reliabilityRating = _program.reliabilityRating, headline = _program.headline, displayName = _program.displayName, isInventoryAvailable = _program.isInventoryAvailable, tags = _program.tags, matching = _program.matching, suggestedPrices = _program.suggestedPrices, type = _program.type;
    var panelTitle = props.panelTitle, position = props.position, newTab = props.newTab, lazyLoadImage = props.lazyLoadImage, tenantConfig = props.tenantConfig, CFPrograms = props.CFPrograms;
    var defaultMatchingPercentage = props.program.defaultMatchingPercentage;
    if (!defaultMatchingPercentage && defaultMatchingPercentage !== 0) {
        defaultMatchingPercentage = props.defaultMatchingPercentage;
    }
    if (Object.keys(props.program).length === 0 && props.program.constructor === Object) {
        return null;
    }
    var programPrice = (0,_util_selectSuggestedPrice__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(type, suggestedPrices, props.tenantConfig, price);
    var imageType = props.imageType || 'thumbnail';
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        className: props.className,
        lg: props.size.lg,
        md: props.size.md,
        sm: props.size.sm,
        xs: props.size.xs,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        rel: "noopener noreferrer",
                        style: {
                            cursor: 'pointer'
                        },
                        href: "".concat(!CFPrograms ? '/program/' : 'https://fundraisers.giveindia.org/projects/').concat(programLink),
                        target: newTab ? '_blank' : '_self',
                        onClick: function() {
                            var eventInfo = {
                                panelTitle: panelTitle,
                                category: cause,
                                programType: type,
                                position: position + 1,
                                productName: title,
                                productTypeId: 1,
                                productId: id,
                                ngo: ngo,
                                programPrice: programPrice,
                                url: window.location.toString()
                            };
                            if (window.eventDispatcher) {
                                window.eventDispatcher.dispatchEventSync('programClick', eventInfo, {
                                    amplitude: true
                                });
                            }
                            return true;
                        },
                        className: "jsx-4112ddb4c4eeda09" + " " + "no-hover-a",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    position: 'relative'
                                },
                                className: "jsx-4112ddb4c4eeda09",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        width: "100%",
                                        style: {
                                            opacity: 1
                                        },
                                        src: image,
                                        alt: alt,
                                        type: imageType,
                                        lazyLoad: lazyLoadImage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            position: 'absolute'
                                        },
                                        className: "jsx-4112ddb4c4eeda09" + " " + "d-flex f-d-row",
                                        /*#__PURE__*/ children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagRow, {
                                            tags: tags,
                                            matching: matching
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-4112ddb4c4eeda09" + " " + "card-body",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-4112ddb4c4eeda09" + " " + "card-tags row",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-4112ddb4c4eeda09" + " " + "col-6 col-lg-6 col-md-12 col-sm-6 p-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    style: {
                                                        textTransform: 'capitalize',
                                                        color: tenantConfig.theme.primaryColor
                                                    },
                                                    className: "jsx-4112ddb4c4eeda09" + " " + "small-text float-left",
                                                    children: cause
                                                })
                                            }),
                                            location ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-4112ddb4c4eeda09" + " " + "col-6 col-lg-6 col-md-12 col-sm-6 p-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    style: {
                                                        textTransform: 'capitalize'
                                                    },
                                                    className: "jsx-4112ddb4c4eeda09" + " " + "small-text mid-grey float-right",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_locationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            color: tenantConfig.theme.primaryColor,
                                                            size: "0.875rem",
                                                            style: {
                                                                display: 'inline-block',
                                                                lineHeight: '0',
                                                                marginRight: '3px',
                                                                width: '0.875rem'
                                                            }
                                                        }),
                                                        location
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                                        style: {
                                            lineHeight: '1.375rem'
                                        },
                                        className: "jsx-4112ddb4c4eeda09" + " " + "card-title text-clamp-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "jsx-4112ddb4c4eeda09" + " " + "darker-grey",
                                                children: displayName || headline || title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "jsx-4112ddb4c4eeda09" + " " + "sh w-100",
                                                children: [
                                                    "\xa0by\xa0",
                                                    ngo
                                                ]
                                            })
                                        ]
                                    }),
                                    !CFPrograms ? !isInventoryAvailable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            position: 'relative'
                                        },
                                        className: "jsx-4112ddb4c4eeda09",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "jsx-4112ddb4c4eeda09" + " " + "card-price",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                style: fullySupportedBoxStyle,
                                                className: "jsx-4112ddb4c4eeda09" + " " + "jsx-3048130722 price",
                                                children: " Fully Supported "
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-4112ddb4c4eeda09" + " " + "card-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                            className: "jsx-4112ddb4c4eeda09" + " " + "price",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils__WEBPACK_IMPORTED_MODULE_5__.PriceTag, {
                                                    price: programPrice,
                                                    theme: tenantConfig.theme,
                                                    session: props.session
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "jsx-4112ddb4c4eeda09" + " " + "sh",
                                                    children: " per month "
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    defaultMatchingPercentage !== matching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_matchedAmount__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        matchValue: matching
                    }) : null
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "4112ddb4c4eeda09",
                children: ".card-price{margin-bottom:10px}\n.card-price h6{margin-bottom:0;\nfont-weight:600}\n.tag-row{margin-bottom:10px}\n.giveassured-position{position:absolute;\nbottom:3px;\nright:3px;\nbackground:white;\npadding:1px 5px;\nborder-radius:5px;\nbox-shadow:0 2px 2px rgba(50, 50, 93, 0), 0 1px 2px rgba(0, 0, 0, 0.08)}"
            })
        ]
    }));
};
var TagRow = function(param) {
    var tags = param.tags, matching = param.matching;
    return typeof tags !== 'undefined' ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "justify-content-end align-self-start tag-row-position d-flex",
        children: tags.map(function(tag, index) {
            /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_elements__WEBPACK_IMPORTED_MODULE_7__/* .Tag */ .V, _objectSpread({}, tag, {
                key: index,
                design: "capsule",
                matchingPercentage: (typeof matching === "undefined" ? "undefined" : _typeof(matching)) !== undefined && matching ? matching.matchingPercentage : null
            }));
        })
    }) : null;
};
ProgramCard.propTypes = {
    program: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
        cause: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        location: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        title: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        ngo: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
        price: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
        image: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
        programLink: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired)
    }).isRequired,
    panelTitle: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({})
};
ProgramCard.defaultProps = {
    size: {
        lg: '4',
        sm: '6',
        xs: '12',
        md: '6'
    },
    className: 'd-flex program-card-11'
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_contextual__WEBPACK_IMPORTED_MODULE_13__/* .subscribe */ .Ld)()(ProgramCard));


/***/ }),

/***/ 15009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// import './heartIcon.scss';
var HeartIcon = function(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: _objectSpread({}, props.style, {
            position: 'relative'
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            alt: "Your donation is matched by us",
            src: props.src,
            style: {
                width: '35px',
                height: '20px'
            }
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (HeartIcon);


/***/ }),

/***/ 11262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: _objectSpread({}, props.style),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            viewBox: "0 0 127.7 201.1",
            xmlns: "http://www.w3.org/2000/svg",
            width: props.size,
            height: props.size,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: props.theme ? props.theme.primaryColor : props.color,
                style: {
                    background: '#FFF'
                },
                d: "M56.1,1.1c9.7-1.3,19.7-0.4,29,3c9.1,3.4,17.6,8.8,24.4,15.8c0.1,0.1,0.3,0.3,0.4,0.4c18.3,19.3,22.6,45,10.5,69.7 c-6.1,12.5-14.1,24.1-21.9,35.6c-13.1,19.1-23.9,39.1-29.9,61.6c-1.2,4.5-2.3,9-3.5,13.5c-0.7,0-1.3,0-2,0c-0.5-2.4-1-4.9-1.6-7.3 C55.2,168.8,44,146.7,29.7,126C22,114.9,13.8,104,7.6,92.2C-8.1,62,3.2,25.1,32.7,8.8C39.9,4.9,47.9,2.2,56.1,1.1z M40.7,64.5 C40.7,78,51.6,89.3,64.4,89.2c13.3,0,24.2-11.3,24.1-24.9c0-13.5-10.6-23.9-24.3-23.8C51,40.5,40.6,51,40.7,64.5z"
            })
        })
    }));
};


/***/ }),

/***/ 61794:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/chrome/elements/icons/matchingLabel.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/* harmony default export */ function matchingLabel(props) {
    var height = props.height;
    var _obj;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (_obj = {
        className: "d-flex",
        style: {
            height: "".concat(height, "px")
        }
    }, _defineProperty(_obj, "className", "jsx-89ee73295f511b7c" + " " + (props.className || "")), _defineProperty(_obj, "children", [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            viewBox: "0 0 50.1 50.1",
            xmlns: "http://www.w3.org/2000/svg",
            height: props.height || props.size,
            className: "jsx-89ee73295f511b7c",
            /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Layer_2",
                className: "jsx-89ee73295f511b7c",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Layer_1-2",
                    className: "jsx-89ee73295f511b7c",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M46.7,27.9l2.5,3.6c-0.6,0.4-1.3,0.7-2,1s-1.3,0.6-2,0.9c0.4,1.4,1,2.7,1.4,4.2l-4.3,0.8l0.3,4.3 c-1.5,0.1-2.9-0.3-4.4-0.3l-0.8,4.3l-4.2-1.5l-1.9,4l-3.6-2.5c-1,1-1.8,2.2-2.9,3.3c-1-1.1-1.9-2.2-2.9-3.3l-3.6,2.5l-1.9-4 c-1.4,0.4-2.7,1-4.1,1.4c-0.3-1.4-0.5-2.8-0.8-4.3c-1.5-0.1-2.9,0.3-4.4,0.3c0-0.7,0.1-1.5,0.1-2.2s0.1-1.4,0.2-2.2 c-1.4-0.4-2.8-0.5-4.3-0.9l1.5-4.2l-4-1.9L3.3,28c-1-1-2.2-1.9-3.3-2.9l3.3-2.8c-0.7-1.3-1.6-2.4-2.4-3.7l3.9-1.9l-1.5-4.1 c1.5-0.4,2.9-0.5,4.3-0.9L7.3,7.4c0.7,0,1.5,0,2.2,0.1l2.2,0.2l0.8-4.3l4.2,1.5l1.9-4l3.6,2.5L25,0c0.5,0.6,1,1.1,1.5,1.7 s0.9,1.1,1.4,1.7l3.6-2.5l1.9,4l4.1-1.5c0.3,1.4,0.5,2.8,0.8,4.3c1.5,0,2.9-0.3,4.4-0.3l-0.3,4.3c1.4,0.4,2.8,0.5,4.2,0.8 c-0.2,0.7-0.4,1.4-0.7,2.1c-0.2,0.7-0.5,1.4-0.7,2.1l4,1.9l-2.5,3.6L50,25C49,26.1,47.8,26.9,46.7,27.9z",
                            className: "jsx-89ee73295f511b7c" + " " + "st0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M21.1,36c-0.3,0-0.6-0.1-0.9-0.3c-0.2-0.1-0.4-0.3-0.5-0.4l-3.5-3.5l-4.5-4.5c-0.5-0.4-0.8-1-0.7-1.6 s0.4-1.1,1-1.3c0.2-0.1,0.4-0.1,0.7-0.1c0.4,0,0.7,0.1,1,0.4c0.1,0.1,0.3,0.2,0.4,0.4l0.1,0.1l6.1,6.1c0.1,0.1,0.2,0.2,0.3,0.3 l0.2,0.2L21,32l0.6-0.6l0.4-0.3l3.1-3.1l13-13c0.2-0.2,0.5-0.4,0.7-0.6c0.2-0.1,0.5-0.2,0.8-0.2c0.9,0,1.7,0.7,1.7,1.7 c0,0.4-0.1,0.7-0.4,1c-0.1,0.1-0.2,0.2-0.3,0.3l-6.2,6.2l-12,12c-0.2,0.3-0.6,0.5-0.9,0.6C21.4,36,21.3,36,21.1,36z",
                            className: "jsx-89ee73295f511b7c" + " " + "st1"
                        })
                    ]
                })
            })
        }),
        (0,jsx_runtime.jsx)((style_default()), {
            id: "89ee73295f511b7c",
            children: ".st0{fill:#42A98B}\n.st1{fill:#FFFFFF}\n.st3{font-size:25px}\n.matched-text-box{background-color:#42A98B;\nheight:35.5;\nwidth:100%}"
        })
    ]), _obj)));
};

// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js
var index_es = __webpack_require__(4726);
;// CONCATENATED MODULE: ./components/chrome/elements/icons/matchingIcon.js





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var tooltipData = "We will contribute a matching amount of your first month's donation to this program from our side to help you increase the impact of your contribution";
var MatchingIcon = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(MatchingIcon, _Component);
    var _super = _createSuper(MatchingIcon);
    function MatchingIcon(props) {
        _classCallCheck(this, MatchingIcon);
        var _this;
        _this = _super.call(this, props);
        _this.state = {};
        _this.matchingIconRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    _createClass(MatchingIcon, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, matchingPercentage = _props.matchingPercentage, height = _props.height, id = _props.id;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-tip": tooltipData,
                            "data-place": "right",
                            "data-for": "tooltip-matching-".concat(id),
                            className: "jsx-5565f70371b663e7" + " " + "tooltip-matching-desktop d-flex f-d-row align-self-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchingLabel, {
                                    height: height
                                }),
                                window ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                    id: "tooltip-matching-".concat(id),
                                    ref: this.matchingIconRef,
                                    "data-multiline": true,
                                    "data-event": "click"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        background: "#42A98B",
                                        margin: '0px 0px 0px -5px',
                                        alignSelf: 'center',
                                        borderTopRightRadius: '5px',
                                        borderBottomRightRadius: '5px'
                                    },
                                    className: "jsx-5565f70371b663e7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            lineHeight: 1,
                                            fontSize: '12px',
                                            color: '#ffffff',
                                            padding: '4px 10px',
                                            fontWeight: 800,
                                            margin: 0,
                                            whiteSpace: 'nowrap'
                                        },
                                        className: "jsx-5565f70371b663e7",
                                        children: [
                                            matchingPercentage,
                                            "% Matched "
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-tip": tooltipData,
                            "data-place": "top",
                            "data-for": "tooltip-matching-".concat(id),
                            className: "jsx-5565f70371b663e7" + " " + "tooltip-matching-mobile d-flex f-d-row align-self-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchingLabel, {
                                    height: height
                                }),
                                window ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                    id: "tooltip-matching-".concat(id),
                                    ref: this.matchingIconRef,
                                    "data-multiline": true,
                                    "data-event": "click"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        background: "#42A98B",
                                        margin: '0px 0px 0px -5px',
                                        alignSelf: 'center',
                                        borderTopRightRadius: '5px',
                                        borderBottomRightRadius: '5px'
                                    },
                                    className: "jsx-5565f70371b663e7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            lineHeight: 1,
                                            fontSize: '12px',
                                            color: '#ffffff',
                                            padding: '4px 10px',
                                            fontWeight: 800,
                                            margin: 0,
                                            whiteSpace: 'nowrap'
                                        },
                                        className: "jsx-5565f70371b663e7",
                                        children: [
                                            matchingPercentage,
                                            "% Matched "
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "5565f70371b663e7",
                            children: ".__react_component_tooltip{width:300px!important}\n@media (min-width:768px) {.tooltip-matching-desktop{display:-webkit-box!important;\ndisplay:-webkit-flex!important;\ndisplay:-ms-flexbox!important;\ndisplay:flex!important}\n.tooltip-matching-mobile{display:none!important}}\n@media (max-width:556px) {.tooltip-matching-desktop{display:none!important}\n.tooltip-matching-mobile{display:-webkit-box!important;\ndisplay:-webkit-flex!important;\ndisplay:-ms-flexbox!important;\ndisplay:flex!important}}"
                        })
                    ]
                }));
            }
        }
    ]);
    return MatchingIcon;
}(react.Component);
/* harmony default export */ var matchingIcon = ((/* unused pure expression or super */ null && (MatchingIcon)));


/***/ }),

/***/ 49635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_waypoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83824);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);




function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var config = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])().publicRuntimeConfig;
var Image = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Image, _Component);
    var _super = _createSuper(Image);
    function Image(props) {
        _classCallCheck(this, Image);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "_handleWaypointEnter", function() {
            _this.setState({
                srcDisplay: _this.state.srcReal
            });
        });
        var _props = _this.props, src = _props.src, type = _props.type, lazyLoad = _props.lazyLoad;
        var placeholder = 'placeholder.jpg';
        if (!src) {
            src = "/static/images/program/".concat(placeholder);
        }
        var pathSegments = src.split('/');
        var fileName = pathSegments[pathSegments.length - 1];
        var path = pathSegments.slice(0, pathSegments.length - 1).join("/");
        var w = 1200;
        if (type === 'program' || type === 'large') {
            w = 1080;
        } else if (type === 'thumbnail') {
            w = 450;
        } else if (type === 'four-col') {
            w = 300;
        }
        var srcDisplay = "".concat(config.cdnUrl).concat(path, "/w").concat(w, "/").concat(fileName);
        if (lazyLoad) {
            srcDisplay = "".concat(config.cdnUrl).concat(path, "/w").concat(w, "/").concat(placeholder);
        }
        _this.state = {
            srcReal: "".concat(config.cdnUrl).concat(path, "/w").concat(w, "/").concat(fileName),
            srcDisplay: srcDisplay
        };
        return _this;
    }
    _createClass(Image, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, src = _props.src, type = _props.type, alt = _props.alt, lazyLoad = _props.lazyLoad, rest = _objectWithoutProperties(_props, [
                    "src",
                    "type",
                    "alt",
                    "lazyLoad"
                ]);
                if (!src) {
                    return null;
                }
                if (typeof alt === 'undefined') {
                    alt = src.substring(src.lastIndexOf('/') + 1);
                    alt = alt.substring(0, alt.lastIndexOf('.'));
                }
                src = this.state.srcDisplay;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        lazyLoad ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_waypoint__WEBPACK_IMPORTED_MODULE_2__/* .Waypoint */ .h, {
                            onEnter: this._handleWaypointEnter,
                            bottomOffset: -200
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", _objectSpread({}, rest, {
                            src: src,
                            alt: alt
                        }))
                    ]
                }));
            }
        }
    ]);
    return Image;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 95820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* reexport safe */ _tag__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79310);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49635);




/***/ }),

/***/ 20314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_heartIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15009);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);



// import './matchedAmount.scss';

var config = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])().publicRuntimeConfig;
var MatchedAmount = function(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: props.matchValue > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                display: 'flex',
                padding: '0 20px 8px',
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_heartIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: "".concat(config.cdnUrl, "/static/icons/checkout/total-impact.svg")
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    style: {
                        marginLeft: '5px'
                    },
                    children: [
                        "Matched ",
                        props.matchValue,
                        "% by us"
                    ]
                })
            ]
        }) : null
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MatchedAmount);


/***/ }),

/***/ 69796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4726);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11752);





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var config = (0,next_config__WEBPACK_IMPORTED_MODULE_4__["default"])().publicRuntimeConfig;
var tagStyle = {
    display: 'inline-block',
    cursor: 'pointer'
};
var textTagStyle = {
    fontWeight: '800'
};
var capsuleTagStyle = {
    color: 'white',
    borderRadius: '20px',
    padding: '2px 10px',
    fontSize: '12px',
    fontWeight: '700'
};
var toolTipStyle = {
    color: 'white',
    padding: '9px 14px',
    maxWidth: '300px'
};
var getTagStyle = function(design, color) {
    if (design === 'capsule') {
        return _objectSpread({}, tagStyle, capsuleTagStyle, {
            backgroundColor: color
        });
    }
    return _objectSpread({}, tagStyle, textTagStyle, {
        color: color
    });
};
var IconTag = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(IconTag, _Component);
    var _super = _createSuper(IconTag);
    function IconTag(props) {
        _classCallCheck(this, IconTag);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "toggle", function() {
            _this.setState({
                tooltipOpen: !_this.state.tooltipOpen
            });
        });
        _this.state = {
            id: "tag-".concat(Math.floor(Math.random() * Math.floor(100000))),
            tooltipOpen: false
        };
        _this.iconTagRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createRef();
        return _this;
    }
    _createClass(IconTag, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, name = _props.name, style = _props.style, color = _props.color, className = _props.className, design = _props.design, id = _props.id, showTooltip = _props.showTooltip, tooltip = _props.tooltip, image = _props.image;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            "data-tip": tooltip,
                            "data-place": "right",
                            "data-for": "tooltip-icontag-".concat(id),
                            className: "jsx-dd00e4936f217a4b" + " " + "d-flex f-d-row align-self-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    id: id,
                                    className: "jsx-dd00e4936f217a4b" + " " + (className || ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "".concat(config.cdnUrl).concat(image),
                                        alt: name,
                                        style: _objectSpread({
                                            maxWidth: '25px',
                                            marginBottom: '0.75rem'
                                        }, style),
                                        "data-tip": tooltip,
                                        "data-for": "tooltip-icontag-".concat(id),
                                        className: "jsx-dd00e4936f217a4b"
                                    })
                                }),
                                window ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    id: "tooltip-icontag-".concat(id),
                                    ref: this.iconTagRef,
                                    "data-multiline": true
                                }) : null
                            ]
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                            id: "dd00e4936f217a4b",
                            children: ".gi-tag{white-space:nowrap!important;\n-webkit-align-self:center!important;\n-ms-flex-item-align:center!important;\nalign-self:center!important}\n.__react_component_tooltip{width:300px!important}"
                        })
                    ]
                }));
            }
        }
    ]);
    return IconTag;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
IconTag.defaultProps = {
    className: 'gi-tag'
};
/* harmony default export */ __webpack_exports__["Z"] = (IconTag);


/***/ }),

/***/ 79310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _iconTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69796);
/* harmony import */ var _textTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83373);
/* harmony import */ var _tagAttributes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4120);
/* harmony import */ var _icons_matchingIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61794);






var Tag = function(props) {
    var tag = props.tag, matching = props.matching;
    var name = props.name, color = props.color, tooltip = props.tooltip, image = props.image, className = props.className;
    try {
        if (typeof tag !== 'undefined') {
            var ref;
            ref = (0,_tagAttributes__WEBPACK_IMPORTED_MODULE_4__/* .getTagAttributes */ .Q)(tag), name = ref.name, color = ref.color, tooltip = ref.tooltip, image = ref.image, ref;
        }
    } catch (err) {}
    if (props.design === 'icon') {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            name: name,
            color: color,
            className: props.className,
            style: props.style,
            design: props.design,
            id: props.id,
            tooltip: tooltip,
            showTooltip: props.showTooltip,
            image: image
        }));
    }
    //  if (props.tag === 'matching') {
    // 	return <MatchingIcon height={30} matchingPercentage={props.matchingPercentage} id={props.id}/>
    // }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_textTag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        name: name,
        color: color,
        className: props.className,
        style: props.style,
        design: props.design,
        id: props.id,
        tooltip: tooltip,
        showTooltip: props.showTooltip
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 4120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getTagAttributes; }
/* harmony export */ });
/* unused harmony export TagAttributes */
var TagAttributes = {
    individualsupport: {
        name: 'Individual Support',
        color: '#006e90',
        tooltip: 'You will receive the background information of the people you will directly support through this program.'
    },
    extremeneed: {
        color: '#DB504A',
        name: 'Extreme Need'
    },
    underfunded: {
        color: '#F7BA2C',
        name: 'Under Funded'
    },
    remotevillages: {
        color: '#8A7090',
        name: 'Remote Villages'
    },
    almostfunded: {
        color: '#80475E',
        name: 'Almost Funded',
        tooltip: 'This program needs less than five donors to be fully funded.'
    },
    onesame: {
        color: '#f18f01',
        name: 'One Same',
        tooltip: 'You will be assigned a beneficiary who benefits from your monthly donation. You will receive regular updates about the progress of your beneficiary',
        image: '/static/images/one-same.svg'
    },
    onedifferent: {
        color: '#43aa8b',
        name: 'One Different',
        tooltip: 'Your donation will help a different beneficiary every month.You will receive regular updates about whom your donation is helping.',
        image: '/static/images/one-different.svg'
    },
    communitysupport: {
        name: 'Community Support',
        color: '#006e90',
        tooltip: 'Donations to this program will fulfill the basic needs of poor communities. You will receive regular updates about the positive change your donation creates.'
    }
};
var getTagAttributes = function(type) {
    return TagAttributes[type];
};


/***/ }),

/***/ 83373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4726);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11752);





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var config = (0,next_config__WEBPACK_IMPORTED_MODULE_4__["default"])().publicRuntimeConfig;
var tagStyle = {
    display: 'inline-block',
    cursor: 'pointer'
};
var textTagStyle = {
    fontWeight: '800'
};
var capsuleTagStyle = {
    color: 'white',
    borderRadius: '20px',
    padding: '2px 10px',
    fontSize: '14px',
    fontWeight: '700'
};
var toolTipStyle = {
    color: 'white',
    padding: '9px 14px',
    maxWidth: '300px'
};
var getTagStyle = function(design, color) {
    if (design === 'capsule') {
        return(_objectSpread({}, tagStyle, capsuleTagStyle, {
            backgroundColor: color
        }));
    }
    return(_objectSpread({}, tagStyle, textTagStyle, {
        color: color
    }));
};
var TextTag = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(TextTag, _Component);
    var _super = _createSuper(TextTag);
    function TextTag(props) {
        _classCallCheck(this, TextTag);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "componentDidMount", function() {
        // this.toggle();
        });
        _defineProperty(_assertThisInitialized(_this), /* UNSAFE_componentWillMount = () => {
		this.setState({
			id: `tag-${Math.floor(Math.random() * Math.floor(100000))}`,
		});
	} */ "toggle", function() {
            _this.setState({
                tooltipOpen: !_this.state.tooltipOpen
            });
        });
        _this.state = {
            id: "tag-".concat(Math.floor(Math.random() * Math.floor(100000))),
            tooltipOpen: false
        };
        _this.textTagRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createRef();
        return _this;
    }
    _createClass(TextTag, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, name = _props.name, style = _props.style, color = _props.color, className = _props.className, design = _props.design, id = _props.id, showTooltip = _props.showTooltip, tooltip = _props.tooltip;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                    children: [
                        name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            "data-tip": tooltip,
                            "data-place": "top",
                            "data-for": "tooltip-textTag-".concat(id),
                            className: "jsx-8edd5762994c325a" + " " + "d-flex f-d-row align-self-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    style: _objectSpread({}, getTagStyle(design, color), style, {
                                        cursor: 'default'
                                    }),
                                    id: id,
                                    className: "jsx-8edd5762994c325a" + " " + (className || ""),
                                    children: [
                                        this.props.origin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-8edd5762994c325a" + " " + "mr-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "".concat(config.cdnUrl, "/static/icons/program-page/warning.svg"),
                                                alt: "tag-icon",
                                                width: 20,
                                                height: 20,
                                                className: "jsx-8edd5762994c325a" + " " + " justify-content-center align-self-center"
                                            })
                                        }),
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    id: "tooltip-textTag-".concat(id),
                                    ref: this.textTagRef,
                                    "data-multiline": true,
                                    "data-event": "click"
                                })
                            ]
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                            id: "8edd5762994c325a",
                            children: ".__react_component_tooltip{width:300px!important}"
                        })
                    ]
                }));
            }
        }
    ]);
    return TextTag;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
TextTag.defaultProps = {
    className: 'gi-tag'
};
/* harmony default export */ __webpack_exports__["Z"] = (TextTag);


/***/ }),

/***/ 6549:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var selectSuggestedPrice = function(programType, programSuggestedPrices, tenantConfig, basePrice) {
    var suggestedPrices = programSuggestedPrices || tenantConfig.program && tenantConfig.program.suggestedPrices;
    if (programType === 'fund' && suggestedPrices && suggestedPrices.length > 0) {
        return suggestedPrices[0];
    }
    return basePrice;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectSuggestedPrice);


/***/ })

}]);